<template>
  <div style="clear: both">
    <v-container fluid>
      <v-row>
        <v-expansion-panels class="mx-3 mb-2" v-model="panel" multiple>
          <v-expansion-panel v-for="(pass, index) in passes" :key="index">
            <v-expansion-panel-title
              :key="index"
              disable-icon-rotate
              @click="show[index] = !show[index]"
              :color="pass.activePass ? 'activePeoplePicker' : 'disabledPeoplePicker'"
              >{{ (pass || {}).label }}
              <template v-slot:actions>
                <v-icon>{{ show[index] ? 'mdi-eye-off-outline' : 'mdi-eye-outline' }}</v-icon>
              </template>
            </v-expansion-panel-title>
            <v-expansion-panel-text :color="pass.activePass ? 'backgroundNormal' : 'backgroundReadOnly'">
              <v-row>
                <v-col cols="12" sm="6">
                  <people-picker-ms
                    :title="(pass || {}).label.concat(' ', $t('Approvers'))"
                    :value="(pass || {}).approvers"
                    readonly
                    :showCounter="true"
                    :color="pass.activePass ? 'activePeoplePicker' : 'disabledPeoplePicker'"
                  ></people-picker-ms>
                </v-col>

                <v-col cols="12" sm="6">
                  <people-picker-ms
                    :title="(pass || {}).label.concat(' ', $t('FYIs'))"
                    :value="(pass || {}).fyis"
                    readonly
                    :showCounter="true"
                    :color="pass.activePass ? 'activePeoplePicker' : 'disabledPeoplePicker'"
                  ></people-picker-ms>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" sm="6">
                  <people-picker-ms
                    :title="pass.label.concat(' ', $t('Additional_Approvers'))"
                    v-model="pass.additionalApprovers"
                    :readonly="getReadonly(pass)"
                    :showCounter="true"
                    :color="pass.activePass ? 'activePeoplePicker' : 'disabledPeoplePicker'"
                    :showExternalSelection="!isCommunityConfidential"
                    showRequired
                    @update="args => handleUpdateAdditionalApprovers(args, index)"
                    @beforeDelete="handleDeleteAdditionalApprovers"
                    :key="index"
                  ></people-picker-ms>
                </v-col>

                <v-col cols="12" sm="6">
                  <people-picker-ms
                    :title="(pass || {}).label.concat(' ', $t('Additional_FYI'))"
                    v-model="(pass || {}).additionalFyis"
                    :readonly="getReadonly(pass)"
                    :showCounter="true"
                    :showExternalSelection="!isCommunityConfidential"
                    :color="pass.activePass ? 'activePeoplePicker' : 'disabledPeoplePicker'"
                    @update="args => handleUpdateAdditionalFyis(args, index)"
                  ></people-picker-ms>
                </v-col>
              </v-row>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import ApprovalService from '@/services/approval.service'
export default {
  name: 'MultipassApprovers',
  data() {
    return {
      show: new Array(this.moc.multiPassCurrentPass).fill(false),
      panel: [this.moc.multiPassCurrentPass - 1],
      passes: [],
      mocApprovals: null
    }
  },
  props: {
    moc: {
      type: Object
    },
    forceReadonly: {
      type: Boolean,
      default: false
    },
    isCommunityConfidential: Boolean
  },
  components: {
    PeoplePickerMs
  },
  methods: {
    getApprovals: async function(mocId) {
      if (mocId !== null) {
        return new Promise((resolve, reject) => {
          ApprovalService.getAllApprovals(mocId)
            .then(data => {
              if (this.setApprovals) this.setApprovals(data)
              if (data.length > 0) {
                resolve(data)
              } else {
                resolve([])
              }
            })
            .catch(e => {
              console.error('Error_GetMOCApprovals in additionalApproverMixin', e)
              reject(e)
            })
        })
      }
    },
    handleDeleteAdditionalApprovers: function(removedUser, people) {
      this.getApprovals(this.moc.mocId).then(() => {
        let ruser = null
        ruser = this.moc.approvalProcessType.multiPass.approvalPasses[
          this.moc.multiPassCurrentPass - 1
        ].additionalApprovers.filter(ru => {
          return ru.id === removedUser.id && ru.decisionPass === this.moc.multiPassCurrentPass
        })

        if ((ruser || {}).length > 0) {
          if (!ruser[0].readonly) {
            let updatedPeople = people.filter(user => {
              return user.id !== removedUser.id
            })

            let currentPass = this.passes.filter(p => {
              return p.activePass === true
            })
            currentPass[0].additionalApprovers = updatedPeople
          }
        }
      })
    },
    handleUpdateAdditionalApprovers: function(usersAction, index) {
      let peopleWithPass =
        usersAction.Users && usersAction.Users.map(p => ({ ...p, decisionPass: this.moc.multiPassCurrentPass }))
      if (this.moc.approvalProcessType.multiPass.approvalPasses[index].additionalApprovers || []) {
        this.moc.approvalProcessType.multiPass.approvalPasses[index].additionalApprovers = peopleWithPass
      }
    },
    handleUpdateAdditionalFyis: function(usersAction, index) {
      let peopleWithPass =
        usersAction.Users && usersAction.Users.map(p => ({ ...p, decisionPass: this.moc.multiPassCurrentPass }))
      if (this.moc.approvalProcessType.multiPass.approvalPasses[index].additionalFyis || []) {
        this.moc.approvalProcessType.multiPass.approvalPasses[index].additionalFyis = peopleWithPass
      }
    },
    getPasses: function() {
      let results = []
      let rowCount = this.moc.multiPassCurrentPass
      let map = this.moc.approvalProcessType.multiPass.approvalPasses.map(a => {
        let pass = a
        if (!pass.additionalFyis) {
          pass.additionalFyis = []
        }
        if (!pass.additionalApprovers) {
          pass.additionalApprovers = []
        }
        return {
          ...pass,
          activePass: false
        }
      })
      for (let x = 0; x < rowCount; x++) {
        map[x].activePass = x === rowCount - 1 ? true : false
        results.push(map[x])
      }
      this.passes = results
    },
    getReadonly(pass) {
      return this.forceReadonly ? true : !pass.activePass
    },
    setMocApprovals(approvals) {
      this.mocApprovals = approvals

      if (this.moc.multiPassCurrentPass !== 0) {
        this.moc.approvalProcessType.multiPass.approvalPasses.forEach(() => {
          this.moc.approvalProcessType.multiPass.approvalPasses[this.moc.multiPassCurrentPass - 1].additionalApprovers = (
            this.moc.approvalProcessType.multiPass.approvalPasses[this.moc.multiPassCurrentPass - 1].additionalApprovers || []
          ).map(u => ({
            ...u,
            readonly: this.setReadonlyAdditionApprover(u)
          }))
          let currentPass = this.passes.filter(p => {
            return p.activePass === true
          })
          currentPass[0].additionalApprovers = this.moc.approvalProcessType.multiPass.approvalPasses[
            this.moc.multiPassCurrentPass - 1
          ].additionalApprovers
        })
      }
    },
    setReadonlyAdditionApprover(user) {
      if (!this.readonlyAdditionalApprovers && this.mocApprovals && this.mocApprovals.length > 0) {
        const isUserWithDecision = this.mocApprovals
          .filter(a => a.decision.key && a.decisionPass === this.moc.multiPassCurrentPass)
          .some(u => u.user.id === user.id)
        return isUserWithDecision
      }
      return false
    }
  },
  created() {
    this.getPasses()
    this.show[this.moc.multiPassCurrentPass - 1] = true

    this.getApprovals(this.moc.mocId).then(async data => {
      this.setMocApprovals(data)
    })
  }
}
</script>

<style scoped></style>
